import { newsItems } from "@/mocks/news";

interface ArticleStructuredDataProps {
  article: (typeof newsItems)[0];
}

export default function ArticleStructuredData({ article }: ArticleStructuredDataProps) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Article",
    "@id": `https://www.gs-granstark.com/news/${article.slug}#article`,
    "headline": article.title,
    "description": article.excerpt,
    "image": article.imageUrl,
    "datePublished": article.isoDate,
    "dateModified": article.isoDate,
    "author": {
      "@type": "Organization",
      "name": "株式会社GRANSTARK",
      "url": "https://www.gs-granstark.com",
    },
    "publisher": {
      "@type": "Organization",
      "name": "株式会社GRANSTARK",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.gs-granstark.com/image/logo.png",
      },
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://www.gs-granstark.com/news/${article.slug}`,
    },
    "articleSection": article.category,
    "inLanguage": "ja",
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}
